/**
 * @description
 * @author zhanghao
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    obj_id: number;
    obj_type: number;
}

export interface IOutput {
    is_outer_obj: number;
    is_outer_expired: number;
}

// 根据课程或者小节id获取购买课程相关信息
// 类型，1：课程(本期传1)， 2： 学习圈  3：小节
// 课程id（企业自己的副本课程id）
export const getObjOuterStatus = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.MARKET_OUTER_OBJ_STATUS, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
